<template>
    <template v-if="show">
        <div class="fixed flex h-full w-full items-center justify-center bg-black/20 p-8 z-50">
            <div
                class="relative flex w-full max-w-md flex-col items-center justify-center overflow-hidden rounded-2xl bg-white px-10 py-20 text-teal-950">
                <img class="absolute h-full w-full object-cover"
                     src="https://images.unsplash.com/photo-1523829949029-7e28e82aa713?q=80&w=3620&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"/>
                <button
                    @click="close"
                    class="absolute top-2.5 right-2.5 rounded-full bg-white/20 p-1 text-black/50 hover:bg-white/50 hover:text-black">
                    <svg class="size-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path
                            d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                    </svg>
                </button>
                <div class="relative z-10 flex flex-col items-center gap-6">
                    <div class="flex flex-col items-center gap-3 text-center">
                        <span class="text-2xl font-medium">Get 50% off forever</span>
                        <span class="opacity-70">Summer deal: 50% off for life. Apply code at checkout. Limited-time offer.</span>
                    </div>
                    <div
                        class="rounded-full bg-white shadow-3xl px-4 py-2.5 tracking-wider font-medium font-mono text-black">
                        PARTNEROSUMMER50
                    </div>
                </div>
            </div>
        </div>
    </template>
</template>

<script setup>

import {ref, onMounted} from "vue";

const show = ref(true);
const cookieName = 'smsl2025ph';

onMounted(() => {
    const cookieValue = getCookie(cookieName);
    if (cookieValue === 1 || cookieValue === '1') {
        show.value = false;
    }
})

const close = () => {
    show.value = false;
    setCookie(cookieName, 1, 1);
};

const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${value}; ${expires}; path=/`;
};

const getCookie = (name) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
};

</script>
